
export default {
  props: {
    questions: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      structuredData: {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        name: this.title || this.$t('components.faqStructuredData.title'),
        inLanguage: this.$i18n.locale,
        mainEntity: this.getFAQItems(),
      },
    }
  },
  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.structuredData),
          type: 'application/ld+json',
        },
      ],
    }
  },
  methods: {
    getFAQItems() {
      return this.questions.map(question => ({
        '@type': 'Question',
        name: this.stripHTML(question.question || question.title),
        acceptedAnswer: {
          '@type': 'Answer',
          text: this.stripHTML(question.answer || question.body || ''),
        },
      }))
    },

    stripHTML(content) {
      if (!content) return ''
      return content.replace(/<\/?[^>]+(>|$)/g, '')
    },
  },
}
